export var SortingOrder;
(function (SortingOrder) {
    SortingOrder["Ascending"] = "asc";
    SortingOrder["Descending"] = "desc";
    SortingOrder["None"] = "none";
})(SortingOrder || (SortingOrder = {}));
